import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Button } from 'reactstrap';
import ValueStreamDetail from 'components/Agile/valueStream/valueStreamDetail';
import ValueStreamTable from 'components/Agile/valueStream/valueStreamTable';
import ValueStreamAdd from 'components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';
import {
    fetchValueStreams,
    handleValueStreamRequestClose,
    showValueStreamLoader,
    onAddValueStream,
    onToggleValueStreamDrawer,
} from 'actions/valueStream';
import {
    fetchPortfolios,
} from 'actions/portfolio';
import {
    fetchTeams,
} from 'actions/team';

const Component = () => {
    const dispatch = useDispatch();

    const width = useSelector(state => state.settings.width);
    const loader = useSelector(state => state.valueStreams.loader);
    const alertMessage = useSelector(state => state.valueStreams.alertMessage);
    const showMessage = useSelector(state => state.valueStreams.showMessage);
    const noContentFoundMessage = useSelector(state => state.valueStreams.noContentFoundMessage);
    const drawerState = useSelector(state => state.valueStreams.drawerState);
    const valueStream = useSelector(state => state.valueStreams.valueStream);
    const valueStreamList = useSelector(state => state.valueStreams.valueStreamList);

    useEffect(() => {
        dispatch(showValueStreamLoader());
        dispatch(fetchValueStreams());
        dispatch(fetchPortfolios());
        dispatch(fetchTeams());
    }, []);

    const valueStreamSideBar = () => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span><IntlMessages id="sidebar.valueStreams" /></span>
                </div>
            </div>

            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                    <div className="module-add-task">
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={() => dispatch(onAddValueStream())}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span><IntlMessages id="valueStream.addValueStream" /></span>
                        </Button>
                    </div>
                </CustomScrollbars>
            </div>
        </div>;
    };

    const valueStreamRequestClose = () => {
        dispatch(handleValueStreamRequestClose());
    };

    return (
        <div className="app-wrapper">
            <div className="app-module animated slideInUpTiny animation-duration-3">
                <div className="d-block d-xl-none">
                    <Drawer
                        touch={true}
                        transitions={true}
                        enableDragHandle={true}
                        open={drawerState}
                        onOpenChange={() => dispatch(onToggleValueStreamDrawer())}
                        sidebar={valueStreamSideBar(valueStream)} />
                </div>
                <div className="app-module-sidenav d-none d-xl-flex">
                    {valueStreamSideBar(valueStream)}
                </div>
                <div className="module-box">
                    <div className="module-box-content">
                        <div className="module-box-header">
                            <span className="icon-btn drawer-btn d-flex d-xl-none"
                                onClick={() => dispatch(onToggleValueStreamDrawer())}>
                                <i className="zmdi zmdi-menu" />
                            </span>
                        </div>
                        <CustomScrollbars className="module-list-scroll scrollbar"
                            style={{ height: width >= 1200 ? 'calc(108vh - 265px)' : 'calc(108vh - 245px)' }}>
                            {loader ?
                                <div
                                    className="loader-view-block h-100">
                                    <div className="loader-view">
                                        <CircularProgress />
                                    </div>
                                </div>
                                :
                                valueStreamList && valueStreamList.length > 0 ?
                                    <Fragment>
                                        <div className="app-main-content">
                                            <ValueStreamTable />
                                            <div style={{ marginTop: 10 }}>
                                                <ValueStreamDetail />
                                            </div>
                                        </div>
                                    </Fragment>
                                    :
                                    <div className="h-100 d-flex align-items-center justify-content-center">
                                        {noContentFoundMessage}
                                    </div>
                            }
                        </CustomScrollbars>

                    </div>
                </div>
            </div>
            <ValueStreamAdd />

            {showMessage && NotificationManager.success(alertMessage, valueStreamRequestClose())}
            <NotificationContainer />

        </div>
    );
};

export default Component;



// WEBPACK FOOTER //
// ./components/Agile/valueStream/component.js